import React, { useState, useEffect } from "react";
import logo from "../assets/img/logoadutem.png";
import logoblanco from "../assets/img/logoADUTEMblanco.png";
import "../assets/css/styles.css";
import axios from "../api/axios";

const Eventos = () => {
  const [filtro, setFiltro] = useState("todos");
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const itemsPorPagina = 6;
  const [paginaActual, setPaginaActual] = useState(1);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/eventos");
        setEventos(res.data.eventos || []);
      } catch (err) {
        console.error("Error cargando eventos:", err);
        setError("No pudimos cargar los eventos. Intenta más tarde.");
      } finally {
        setLoading(false);
      }
    };

    fetchEventos();
  }, []);

  const eventosFiltrados = eventos.filter((item) => {
    if (filtro === "todos") return true;
    if (filtro === "evento")
      return item.tipo_evento === "PRINCIPAL" || item.tipo_evento === "PROMOCIONAL";
    if (filtro === "noticia") return item.tipo_evento === "INFORMATIVO";
    return true;
  });

  const totalPaginas = Math.ceil(eventosFiltrados.length / itemsPorPagina);
  const indiceInicio = (paginaActual - 1) * itemsPorPagina;
  const indiceFin = indiceInicio + itemsPorPagina;
  const itemsPagina = eventosFiltrados.slice(indiceInicio, indiceFin);

  useEffect(() => {
    setPaginaActual(1);
  }, [filtro]);

  return (
    <>
    <div className="d-flex flex-column min-vh-100">
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container">
    <a className="navbar-brand" href="/">
      <img
        src={logo}
        alt="Logo ADUTEM"
        height="90"
        className="logo-adutem"
      />
    </a>

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarMenu"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarMenu">
      <ul className="navbar-nav ms-auto align-items-center">
        <li className="nav-item me-lg-5">
          <a className="nav-link" href="/">Inicio</a>
        </li>

        <li className="nav-item me-lg-5">
          <a className="nav-link" href="/nosotros">Nosotros</a>
        </li>

        <li className="nav-item me-lg-5">
          <a className="nav-link" href="/convenios">Convenios</a>
        </li>

        <li className="nav-item me-lg-5">
          <a className="nav-link" href="/eventos">Eventos</a>
        </li>

        <li className="nav-item me-lg-5">
          <a className="nav-link" href="/login">Login</a>
        </li>

        <li className="nav-item">
          <a
            className="btn btn-socio px-4 py-2 rounded-1"
            href="/sersocio"
          >
            Ser Socio
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

      {/* LISTA DE EVENTOS */}
      <main className="flex-grow-1">
  <section
  className="py-5"
  style={{ backgroundColor: "#f0f7f0" }}
>
        <div className="container">
          {/* Filtros mejorados */}
          {/* ================= FILTROS MEJORADOS ================= */}
<div className="text-center mb-5">
  <div className="d-inline-flex flex-wrap justify-content-center gap-2 p-2 bg-white shadow-sm rounded-4 border">
    {[
      { key: "todos", label: "Todos", icon: "bi-grid-3x3-gap" },
      { key: "evento", label: "Eventos", icon: "bi-calendar-event" },
      { key: "noticia", label: "Noticias", icon: "bi-newspaper" },
    ].map(({ key, label, icon }) => {
      // Contamos cuántos hay de cada tipo
      const count =
        key === "todos"
          ? eventos.length
          : key === "evento"
          ? eventos.filter(
              (e) =>
                e.tipo_evento === "PRINCIPAL" || e.tipo_evento === "PROMOCIONAL"
            ).length
          : eventos.filter((e) => e.tipo_evento === "INFORMATIVO").length;

      const isActive = filtro === key;

      return (
        <button
          key={key}
          type="button"
          onClick={() => setFiltro(key)}
          className={`
            btn d-flex align-items-center gap-2 px-4 py-2 rounded-3 fw-semibold
            transition-all border-0
            ${isActive
              ? "bg-success text-white shadow-sm"
              : "bg-transparent text-success hover-bg-success-subtle"
            }
          `}
          style={{
            minWidth: "130px",
            transition: "all 0.25s ease",
          }}
        >
          <i className={`bi ${icon} fs-5`}></i>
          <span>{label}</span>
          <span
            className={`
              badge rounded-pill ms-1
              ${isActive ? "bg-white text-success" : "bg-success-subtle text-success"}
            `}
            style={{ fontSize: "0.75rem" }}
          >
            {count}
          </span>
        </button>
      );
    })}
  </div>
</div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger text-center">{error}</div>
          ) : eventosFiltrados.length === 0 ? (
            <div className="alert alert-info text-center py-4">
              No hay eventos disponibles en este momento
            </div>
          ) : (
            <>
              <div className="row g-4">
                {itemsPagina.map((item) => (
                  <div className="col-md-6 col-lg-4" key={item.id}>
                    <div className="card h-100 border-0 shadow hover-shadow-lg transition-all duration-300 overflow-hidden bg-white rounded-4">
                      {/* Imagen con aspect-ratio moderno */}
                      <div
  style={{
    width: "100%",
    height: "380px",
    backgroundColor: "#f5f5f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    cursor: "pointer",
  }}
  onClick={() =>
    setImagenSeleccionada(
      item.imagen_portada ||
        "https://via.placeholder.com/800x600?text=Sin+Imagen"
    )
  }
>
  <img
    src={
      item.imagen_portada ||
      "https://via.placeholder.com/800x600?text=Sin+Imagen"
    }
    alt={item.titulo}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src =
        "https://via.placeholder.com/800x600?text=Sin+Imagen";
    }}
  />
</div>

                      <div className="card-body d-flex flex-column p-4">
                        {/* Título ahora en verde */}
                        <h5 className="card-title fw-bold mb-3 text-success fs-4">
                          {item.titulo}
                        </h5>

                        <p className="card-text text-muted flex-grow-1 mb-4">
                          {item.descripcion || "Sin descripción disponible"}
                        </p>

                        {/* Botones según tipo */}
                        <div className="mt-auto">
                          {item.tipo_evento === "PRINCIPAL" && item.url_pdf && (
                            <a
                              href={item.url_pdf}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-success rounded-pill px-4 py-2 fw-semibold"
                            >
                              Ver PDF
                            </a>
                          )}

                          {item.tipo_evento === "PROMOCIONAL" && item.url_externa && (
                            <a
                              href={item.url_externa}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-success rounded-pill px-4 py-2 fw-semibold"
                            >
                              Ver más
                            </a>
                          )}

                          {item.tipo_evento === "INFORMATIVO" && (
                            <button className="btn btn-outline-success rounded-pill px-4 py-2 disabled">
                              Informativo
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Paginación mejorada */}
              {totalPaginas > 1 && (
                <div className="d-flex justify-content-center mt-5">
                  <ul className="pagination pagination-lg">
                    {paginaActual > 1 && (
                      <li className="page-item">
                        <button
                          className="page-link rounded-start-pill px-4"
                          onClick={() => setPaginaActual(paginaActual - 1)}
                        >
                          Anterior
                        </button>
                      </li>
                    )}

                    {[...Array(totalPaginas)].map((_, i) => {
                      const pagina = i + 1;
                      return (
                        <li
                          key={pagina}
                          className={`page-item ${paginaActual === pagina ? "active" : ""}`}
                        >
                          <button
                            className="page-link px-4"
                            onClick={() => setPaginaActual(pagina)}
                          >
                            {pagina}
                          </button>
                        </li>
                      );
                    })}

                    {paginaActual < totalPaginas && (
                      <li className="page-item">
                        <button
                          className="page-link rounded-end-pill px-4"
                          onClick={() => setPaginaActual(paginaActual + 1)}
                        >
                          Siguiente
                        </button>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </>
          )}
        </div>
        {/* ================= MODAL IMAGEN COMPLETA ================= */}
{imagenSeleccionada && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
    style={{
      backgroundColor: "rgba(0, 0, 0, 0.88)",
      zIndex: 1055,
      padding: "20px",
    }}
    onClick={() => setImagenSeleccionada(null)}
  >
    {/* Botón cerrar */}
    <button
      type="button"
      className="btn btn-light rounded-circle position-absolute"
      style={{
        top: "20px",
        right: "20px",
        width: "45px",
        height: "45px",
        zIndex: 1060,
        fontSize: "20px",
        fontWeight: "bold",
      }}
      onClick={() => setImagenSeleccionada(null)}
      aria-label="Cerrar"
    >
      ✕
    </button>

    {/* Imagen */}
    <img
      src={imagenSeleccionada}
      alt="Evento ampliado"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "95vw",
        maxHeight: "92vh",
        width: "auto",
        height: "auto",
        objectFit: "contain",
        borderRadius: "10px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
      }}
    />
  </div>
)}
          </section>
</main>
      

       {/* ================= FOOTER COMPACTO ================= */}
      <footer className="bg-verde-oscuro text-white py-4">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-4 text-center text-lg-start">
              <img
                src={logoblanco}
                alt="Logo ADUTEM"
                height="60"
                className="me-3 mb-2"
              />
              <p className="mb-0 small opacity-80">
                Asociación de Docentes de la Universidad Técnica de Manabí
              </p>
            </div>

            <div className="col-lg-4 text-center">
              <h6 className="fw-bold mb-2 small text-uppercase">Dirección</h6>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-geo-alt me-2"></i>
                Calle: Chile y Los Amigos
              </p>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-telephone me-2"></i>
                Teléfono: (05) 2632-200 / 0999162353
              </p>
              <p className="mb-3 small opacity-90">
                <i className="bi bi-envelope me-2"></i>
                adutem@utm.edu.ec
              </p>

              <h6 className="fw-bold mb-3 small text-uppercase">Redes Sociales</h6>
              <div className="d-flex justify-content-center gap-4">
                <a href="https://www.instagram.com/adutem2025?igsh=MWU2aXJhZnh1Zjhtag==" className="text-white fs-4 opacity-80"><i className="bi bi-instagram"></i></a>
                <a href="https://www.facebook.com/share/1EQhuaFzqH/?mibextid=wwXIfr" className="text-white fs-4 opacity-80"><i className="bi bi-facebook"></i></a>
                <a href="https://youtube.com/@adutem?si=dluaO2vDTwiUwyfh" className="text-white fs-4 opacity-80"><i className="bi bi-youtube"></i></a>
              </div>
            </div>

            <div className="col-lg-4"></div>
          </div>

          <div className="text-center mt-3 pt-3 border-top border-secondary border-opacity-50">
            <small className="opacity-70">
              ADUTEM 2022 - 2025 © Todos los derechos reservados
            </small>
          </div>
        </div>
        
      </footer>
      
    </div>  
    </>
  );
};

export default Eventos;